import { CommonModule } from '@angular/common';
import { Component, inject, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { SceneMeta, ScenePathEnum, SceneSelect, sceneMeta } from '@scenes';
import { AppService, MessageService } from '@services';
import { SceneStore } from '@stores';
import { LottieComponent } from 'ngx-lottie';
import { DialogModule } from 'primeng/dialog';

@Component({
  selector: 'bo-scene-launcher',
  templateUrl: './scene-launcher.component.html',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    FormsModule,
    DialogModule,
    LottieComponent,
  ],
})
export class SceneLauncherComponent {
  protected appService = inject(AppService);
  private messageService = inject(MessageService);
  private sceneStore = inject(SceneStore);

  scenePathEnum = ScenePathEnum;
  selectedScene: SceneSelect = null;
  showLoader = signal(false);

  showSceneLauncher = this.appService.showSceneLauncher;

  toggleSceneLauncher() {
    this.appService.showSceneLauncher.set(!this.appService.showSceneLauncher());
  }

  selectScene(scene: SceneSelect) {
    this.selectedScene = scene;
    this.showLoader.set(true);
    this.toggleSceneLauncher();
    this.sceneSetup(sceneMeta[scene]);
  }

  selectDemo(scene: SceneSelect) {
    this.selectedScene = scene;
    this.showLoader.set(true);
    this.appService.demoMode.set(true);
    this.showLoader.set(false);
    this.toggleSceneLauncher();
    this.sceneSetup(sceneMeta[scene]);
  }

  sceneSetup(scene: SceneMeta) {
    this.messageService.clearMessages();
    this.sceneStore.getSceneData(scene.identifier);
  }
}
